export const IMPACT_NETWORK_PREFIX = 'IMPACT_NETWORK||'

export const decodeCompanyIdParam = (id: unknown): string => {
  if (typeof id !== 'string') return ''
  try {
    return decodeURIComponent(id)
  } catch {
    return id
  }
}

export const isImpactNetworkCompanyId = (id: unknown): boolean => {
  const decoded = decodeCompanyIdParam(id)
  return decoded.startsWith(IMPACT_NETWORK_PREFIX)
}

export const companyAdminPath = (id: string): string => {
  return `/companies/${encodeURIComponent(id)}`
}
